import { Phone, MessageSquare, Mail, Calendar, Clock } from "lucide-react";
import { JEREMY, PHOTOS } from "@/lib/jeremy";
import { Link } from "react-router-dom";

export default function ContactJeremy() {
  const digits = JEREMY.contact.phone.replace(/\D/g, "");
  return (
    <section className="py-20 md:py-28 bg-[#0B261E] text-[#F8FAFC]" data-testid="contact-jeremy-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <div className="relative rounded-[2rem] overflow-hidden border-4 border-[#FEF3C7]/20 shadow-2xl">
            <img src={PHOTOS.casual} alt="Jeremy — your Virginia solar guide" className="w-full h-[380px] md:h-[460px] object-cover" data-testid="contact-jeremy-photo" />
            <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#0B261E]/95 to-transparent">
              <div className="eyebrow" style={{ color: "#FEF3C7" }}>Jeremy · Fredericksburg, VA</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="eyebrow" style={{ color: "#FEF3C7" }}>Contact Jeremy</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold">
            Text me. Call me. Send me your bill.
          </h2>
          <p className="mt-4 text-lg text-[#F8FAFC]/85 max-w-xl">
            No-pressure conversation. If solar isn't a fit for your home, I'll tell you.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            <a href={`tel:${digits}`} className="rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-4 flex items-center gap-4 transition" data-testid="contact-call-link">
              <div className="w-10 h-10 rounded-xl bg-[#D97706] flex items-center justify-center shrink-0"><Phone className="w-4 h-4 text-[#FDFBF7]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest font-mono-metric text-[#FEF3C7]">Call</div>
                <div className="font-mono-metric text-lg">{JEREMY.contact.phone}</div>
              </div>
            </a>
            <a href={`sms:${digits}`} className="rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-4 flex items-center gap-4 transition" data-testid="contact-text-link">
              <div className="w-10 h-10 rounded-xl bg-[#D97706] flex items-center justify-center shrink-0"><MessageSquare className="w-4 h-4 text-[#FDFBF7]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest font-mono-metric text-[#FEF3C7]">Text</div>
                <div className="font-mono-metric text-lg">{JEREMY.contact.text}</div>
              </div>
            </a>
            <a href={`mailto:${JEREMY.contact.email}`} className="rounded-2xl bg-white/5 hover:bg-white/10 border border-white/10 p-4 flex items-center gap-4 transition" data-testid="contact-email-link">
              <div className="w-10 h-10 rounded-xl bg-[#D97706] flex items-center justify-center shrink-0"><Mail className="w-4 h-4 text-[#FDFBF7]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest font-mono-metric text-[#FEF3C7]">Email</div>
                <div className="text-sm">{JEREMY.contact.email}</div>
              </div>
            </a>
            <Link to="/qualify" className="rounded-2xl bg-[#D97706] hover:bg-[#B45309] p-4 flex items-center gap-4 transition" data-testid="contact-schedule-link">
              <div className="w-10 h-10 rounded-xl bg-[#0F382C] flex items-center justify-center shrink-0"><Calendar className="w-4 h-4 text-[#FEF3C7]" /></div>
              <div>
                <div className="text-xs uppercase tracking-widest font-mono-metric text-[#FEF3C7]">Schedule a call</div>
                <div className="text-sm text-[#FDFBF7]">Via qualification form</div>
              </div>
            </Link>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-4 text-xs text-[#F8FAFC]/70">
            <div className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {JEREMY.contact.hours}</div>
            <div>·</div>
            <div>{JEREMY.contact.responseTime}</div>
          </div>
          {JEREMY.contact.isPlaceholder && (
            <p className="mt-4 text-xs text-[#FEF3C7]/70 italic">Contact details shown are placeholders. They will publish once Jeremy approves them in the admin dashboard.</p>
          )}
        </div>
      </div>
    </section>
  );
}
